<template>
  <div>
    <div class="body" v-loading="isLoading">
      <el-table
        ref="singleTable"
        :header-cell-class-name="headerBackgroundColor"
        :row-class-name="rowClass"
        :data="data"
        height="calc(100vh - 190px)"
        highlight-current-row
        current-row-key="companyName"
        @filter-change="onTableFilterChange"
        filter-placement="top"
      >
        <el-table-column
          min-width="80px"
          width="312px"
          show-overflow-tooltip
          label="公司名称"
          prop="companyName"
        >
          <template slot-scope="scope">
            <router-link
              class="router-result-page"
              :to="{name: 'result-page', query: {q: scope.row.companyName}}"
            ><img v-if="scope.row.enableAlarm===true" class="img" src="@/assets/img/small-bell2.svg"/>{{scope.row.companyName}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="60px"
          width="128px"
          label="正面舆情指数"
          prop="compPosCnt"
          align="left"
        >
          <template slot="header" slot-scope="scope">
            <div @click="onCompPosCntSort">
              <div @onScope="scope" class="header-comp">正面舆情指数</div>
              <i
                :class="{'arrow-normal':clickPosCount % 3 == 0,'arrow-up':clickPosCount % 3 == 1,'arrow-down':clickPosCount % 3 == 2}"
              ></i>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="comp-pos-cnt">{{scope.row.compPosCnt}}</div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="60px"
          width="128px"
          label="负面舆情指数"
          prop="compNegCnt"
          align="left"
        >
          <template slot="header" slot-scope="scope">
            <div @click="onCompNegCntSort">
              <div @onScope="scope" class="header-comp">负面舆情指数</div>
              <i
                :class="{'arrow-normal':clickNegCount % 3 == 0,'arrow-up':clickNegCount % 3 == 1,'arrow-down':clickNegCount % 3 == 2}"
              ></i>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="comp-neg-cnt">{{scope.row.compNegCnt}}</div>
          </template>
        </el-table-column>
        <el-table-column min-width="60px" width="98px" label="公司热度" prop="compTotCnt" align="left">
          <template slot="header" slot-scope="scope">
            <div @click="onCompTotCntSort">
              <div @onScope="scope" class="header-comp">公司热度</div>
              <i
                :class="{'arrow-normal':clickTotCount % 3 == 0,'arrow-up':clickTotCount % 3 == 1,'arrow-down':clickTotCount % 3 == 2}"
              ></i>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="comp-tot-cnt">{{scope.row.compTotCnt}}</div>
          </template>
        </el-table-column>
        <el-table-column
          class-name="group-filter"
          filter-placement="bottom"
          prop="monitorGroups"
          label="类别"
          :filters="getFilters()"
        >
          <template slot-scope="scope">
            <el-tag
              class="tag"
              v-for="(item, index) in scope.row.monitorGroups"
              :key="index"
            >{{item}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="104px" label="操作">
          <template slot-scope="scope">
            <div class="operation-class">
              <el-popover
                placement="bottom"
                trigger="hover"
                content="告警设置"
                :visible-arrow=false>
                <div slot="reference" class="edit-hover">
                  <entity-alarm-stand-alone-setting class="edit-notification-icon" @entityAlarmStatus="entityAlarmStatus" :search-text="scope.row.companyName"></entity-alarm-stand-alone-setting>
                </div>
              </el-popover>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="编辑类别"
                :visible-arrow=false>
                <div slot="reference" class="edit-hover">
                  <i class="edit" @click="onEditBtnClick(scope.row)"></i>
                </div>
              </el-popover>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="取消关注"
                :visible-arrow=false>
                <div slot="reference" class="delete-hover">
                  <i class="delete" @click="onDeleteBtnClick(scope.row)"></i>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title=''
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="524px"
      top="33vh"
    >
      <span class="dialog-delete-monitor">取消监控</span>
      <span class="dialog-company">{{this.companyName}}</span>
      <span class="dialog-delete-monitor">?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onOKDeleteBtnClick()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="自定类别"
      class="edit-dialog"
      :visible.sync="groupDialogVisible"
      width="524px"
      @close="groupHandleClose"
      top="33vh"
    >
      <span class="dialog-body">
        <span
          class="item-list"
          :class="{'li-back-ground': activeIndexes.indexOf(groupsItem)!=-1}"
          v-for="(groupsItem,index) in groupsName"
          :key="index"
          @click="onAddGroupName(groupsItem)"
        >
          <el-tag class="tag-dialog">{{groupsItem}}</el-tag>
        </span>
        <el-button class="add-group-btn" @click="onAddGroup" v-show="isAddGroup">
          <img class="plus-circle" src="../../assets/img/plus-circle.svg"/>
          添加类别
        </el-button>
        <span class="row input-value" v-show="!isAddGroup">
          <input class="input" type="text" v-model.trim="inputValue">
          <el-button class="save" @click="onSave">保存</el-button>
          <el-button class="cancel" @click="onCancel">取消</el-button>
        </span>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onOKBtnClick">完 成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import authService from '@/services/authService';
import questionQuery from '@/rest/questionQuery';
import EntityAlarmStandAloneSetting from '@/components/news-monitor/EntityAlarmStandAloneSetting';

export default {
  data() {
    return {
      timer: null,
      selectedCompanyName: '',
      clickPosCount: 0,
      clickNegCount: 0,
      clickTotCount: 0,
      data: [],
      isLoading: false,
      companyName: '',
      groupsName: [],
      groups: [],
      inputValue: '',
      isAddGroup: true,
      activeIndexes: [],
      groupDialogVisible: false,
      dialogVisible: false,
      totalCount: 0,
      monitorGroups: [],
      username: '',
      queryObj: {
        pageNum: 1,
        pageSize: 10,
        groups: [],
        sortBy: '',
        sortOrder: ''
      }
    };
  },
  props: {
    selectedCompany: {
      type: String
    },
    tableData: {
      type: Array
    }
  },
  watch: {
    tableData() {
      this.fetchTableData();
    },
    selectedCompany(val) {
      this.selectedCompanyName = val;
      const currentData = this.data.filter((ele) => {
        if (ele.companyName === val) return true;
        return false;
      });
      if (currentData.length === 1) {
        this.$refs.singleTable.setCurrentRow(currentData[0]);
        document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop = this.data.indexOf(currentData[0]) * 62;
      } else if (!currentData.length) {
        questionQuery.addMonitor(this.username, val, []).then(() => {
          this.fetchTableData();
          document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop = 0;
        });
      }
    }
  },
  components: {
    EntityAlarmStandAloneSetting
  },
  methods: {
    entityAlarmStatus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.fetchTableData();
      }, 1000);
    },
    onCompPosCntSort() {
      if (this.clickPosCount % 3 === 0) {
        this.queryObj.sortOrder = 'Asc';
        this.queryObj.sortBy = 'Pos';
        this.clickPosCount++;
      } else if (this.clickPosCount % 3 === 1) {
        this.queryObj.sortOrder = 'Desc';
        this.queryObj.sortBy = 'Pos';
        this.clickPosCount++;
      } else if (this.clickPosCount % 3 === 2) {
        this.queryObj.sortOrder = '';
        this.queryObj.sortBy = '';
        this.clickPosCount++;
      }
      this.clickNegCount = 0;
      this.clickTotCount = 0;
      this.fetchTableData();
    },
    onCompNegCntSort() {
      if (this.clickNegCount % 3 === 0) {
        this.queryObj.sortOrder = 'Asc';
        this.queryObj.sortBy = 'Neg';
        this.clickNegCount++;
      } else if (this.clickNegCount % 3 === 1) {
        this.queryObj.sortOrder = 'Desc';
        this.queryObj.sortBy = 'Neg';
        this.clickNegCount++;
      } else if (this.clickNegCount % 3 === 2) {
        this.queryObj.sortOrder = '';
        this.queryObj.sortBy = '';
        this.clickNegCount++;
      }
      this.clickPosCount = 0;
      this.clickTotCount = 0;
      this.fetchTableData();
    },
    onCompTotCntSort() {
      if (this.clickTotCount % 3 === 0) {
        this.queryObj.sortOrder = 'Asc';
        this.queryObj.sortBy = 'Tot';
        this.clickTotCount++;
      } else if (this.clickTotCount % 3 === 1) {
        this.queryObj.sortOrder = 'Desc';
        this.queryObj.sortBy = 'Tot';
        this.clickTotCount++;
      } else if (this.clickTotCount % 3 === 2) {
        this.queryObj.sortOrder = '';
        this.queryObj.sortBy = '';
        this.clickTotCount++;
      }
      this.clickPosCount = 0;
      this.clickNegCount = 0;
      this.fetchTableData();
    },
    headerBackgroundColor({ rowIndex, columnIndex }) {
      let tmp = null;
      if (rowIndex === 0 && columnIndex === 1 && this.clickPosCount % 3 === 0) {
        tmp = 'header-pos-normal';
      } else if (rowIndex === 0 && columnIndex === 1 && this.clickPosCount % 3 === 1) {
        tmp = 'header-pos-up';
      } else if (rowIndex === 0 && columnIndex === 1 && this.clickPosCount % 3 === 2) {
        tmp = 'header-pos-down';
      } else if (rowIndex === 0 && columnIndex === 4) {
        tmp = 'header-groups';
      } else if (rowIndex === 0 && columnIndex === 0) {
        tmp = 'header-companies';
      } else if (rowIndex === 0 && columnIndex === 5) {
        tmp = 'header-operation';
      } else if (rowIndex === 0 && columnIndex === 2 && this.clickNegCount % 3 === 0) {
        tmp = 'header-neg-normal';
      } else if (rowIndex === 0 && columnIndex === 2 && this.clickNegCount % 3 === 1) {
        tmp = 'header-neg-up';
      } else if (rowIndex === 0 && columnIndex === 2 && this.clickNegCount % 3 === 2) {
        tmp = 'header-neg-down';
      } else if (rowIndex === 0 && columnIndex === 3 && this.clickTotCount % 3 === 0) {
        tmp = 'header-tot-normal';
      } else if (rowIndex === 0 && columnIndex === 3 && this.clickTotCount % 3 === 1) {
        tmp = 'header-tot-up';
      } else if (rowIndex === 0 && columnIndex === 3 && this.clickTotCount % 3 === 2) {
        tmp = 'header-tot-down';
      }
      return tmp;
    },
    rowClass() {
      return 'row-class';
    },
    fetchTableData() {
      this.isLoading = true;
      questionQuery.getMonitorList(this.username, this.queryObj).then(data => {
        this.isLoading = false;
        this.data = data.pageItems || [];
        this.totalCount = data.totalCount;
      });
    },
    getFilters() {
      return this.monitorGroups.map(item => {
        return {
          text: item,
          value: item
        };
      });
    },
    handleCurrentChange(pageNum) {
      this.queryObj.pageNum = pageNum;
      this.fetchTableData();
    },
    groupHandleClose() {
      this.dialogVisible = false;
      this.activeIndexes = [];
      this.groups = [];
    },
    onEditBtnClick(row) {
      this.groupDialogVisible = true;
      if (row.monitorGroups != null) {
        this.activeIndexes = [...row.monitorGroups];
        this.groups = [...row.monitorGroups];
      }
      this.companyName = row.companyName;
      questionQuery.getMonitorGroupList(this.username).then(
        data => {
          this.groupsName = data;
        },
        () => {
          this.$message.error('获取公司类别失败');
        }
      );
    },
    onAddGroupName(groupsItem) {
      if (this.activeIndexes.indexOf(groupsItem) === -1) {
        this.activeIndexes.push(groupsItem);
        this.groups.push(groupsItem);
      } else {
        this.activeIndexes.splice(this.activeIndexes.indexOf(groupsItem), 1);
        this.groups.splice(this.groups.indexOf(groupsItem), 1);
      }
    },
    onAddGroup() {
      this.isAddGroup = !this.isAddGroup;
    },
    onSave() {
      if (this.inputValue === '') {
        this.isAddGroup = true;
      } else {
        this.groupName = this.inputValue;
        this.groupsName.push(this.inputValue);
        this.groups.push(this.inputValue);
        this.activeIndexes.push(this.inputValue);
        this.inputValue = '';
        this.isAddGroup = true;
        questionQuery.addMonitorGroup(this.username, this.groupName).then(
          () => {},
          () => {
            this.$message.error('加组失败！');
          }
        );
      }
    },
    onCancel() {
      this.inputValue = '';
      this.isAddGroup = true;
    },
    onOKBtnClick() {
      questionQuery
        .updateMonitor(this.username, this.companyName, this.groups)
        .then(
          () => {
            this.groupDialogVisible = false;
            this.fetchTableData();
          },
          () => {
            this.$message.error('加监控失败！');
          }
        );
    },
    onDeleteBtnClick(row) {
      this.dialogVisible = true;
      this.companyName = row.companyName;
    },
    onOKDeleteBtnClick() {
      questionQuery.deleteMonitor(this.username, this.companyName).then(
        () => {
          this.dialogVisible = false;
          this.fetchTableData();
        },
        () => {
          this.$message.error('取消监控失败！');
        }
      );
    },
    onTableFilterChange(filterObj) {
      const keys = Object.keys(filterObj);
      this.queryObj.groups = filterObj[keys[0]];
      this.fetchTableData();
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.fetchTableData();
    questionQuery.getMonitorGroupList(this.username).then(data => {
      this.monitorGroups = data || [];
      this.monitorGroups.unshift('全部');
      this.monitorGroups.unshift('无类别');
    });
  }
};
</script>
<style lang="scss" scoped>
.body {
  min-height: 359px;
}
/deep/ .el-table_1_column_1 {
  padding-left: 6px;
}
/deep/ .el-table {
  th.gutter {
    background-color: #3b3a3f;
  }
}
.router-result-page {
  color: #42b3ff;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-family: "DIN-Bold";
  &:hover {
    font-weight: bold;
    text-decoration: underline;
  }
  .img {
    vertical-align: middle;
    margin-right: 4px;
    margin-bottom: 3px;
  }
}
/deep/ .el-table th div {
  height: 48px;
  line-height: 48px;
  padding-right: 2px;
}
/deep/ .el-table__column-filter-trigger {
  margin-left: 5px;
  .el-icon-arrow-down {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url("../../assets/img/caret-down.svg");
  }
  .el-icon-arrow-up {
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url("../../assets/img/caret-up.svg");
  }
}
.header-comp {
  display: inline;
  margin-left: -21px;
  font-family: "DIN-Regular";
}
.arrow-normal {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("../../assets/img/sortArrow-normal.svg");
  vertical-align: middle;
}
.arrow-down {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("../../assets/img/arrow-down-normal.svg");
  vertical-align: middle;
  &:hover {
    background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
  }
}
.arrow-up {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("../../assets/img/arrow-up-normal.svg");
  vertical-align: middle;
}
.comp-pos-cnt {
  color: #fc4a55;
  font-family: "DIN-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.comp-neg-cnt {
  color: #54cea4;
  font-family: "DIN-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.comp-tot-cnt {
  color: #ffffff;
  font-family: "DIN-Regular";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.group-filter {
  height: 36px;
  border: solid 2px rgba(69, 168, 204, 0.4);
  border-radius: 2px;
  color: #ffffff;
  background-color: transparent;
  cursor: pointer;
  &:hover {
    border: solid 2px #45a8cc;
  }
  .tag {
    height: 24px;
    line-height: 24px;
    padding: 0 6px;
    margin-right: 4px;
    margin-bottom: 4px;
    border: none;
    border-radius: 2px;
    color: #ffffff;
    font-family: "DIN-Regular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    background-color: rgba(69, 168, 204, 0.2);
  }
}
.operation-class {
  display: flex;
  justify-content: space-around;
  .edit-notification-icon {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/img/small-bell.svg");
    background-size: cover;
  }
  .edit-hover {
    width: 24px;
    height: 24px;
    padding: 3px 4px 5px;
    &:hover {
      border-radius: 2px;
      background-color: #504d52;
    }
    &:active {
      border-radius: 2px;
      background-color: #605c61;
    }
    .edit {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/edit.svg");
      background-size: 100% 100%;
      align-items: center;
      cursor: pointer;
    }
  }
  .delete-hover {
    width: 24px;
    height: 24px;
    padding: 3px 4px 5px;
    &:hover {
      border-radius: 2px;
      background-color: #504d52;
    }
    &:active {
      border-radius: 2px;
      background-color: #605c61;
    }
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/delete.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}
.dialog-delete-monitor {
  margin: 0 6px;
  color: #ffffff;
  font-size: 20px;
}
.dialog-company {
  color: #45a8cc;
  font-size: 20px;
}
.pager {
  display: flex;
  justify-content: center;
  height: 80px;
  margin-top: 26px;
  & /deep/ {
    .el-pagination {
      .el-pager li {
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        margin: 0 0.125rem;
        color: #b3b2b3;
        font-family: "DIN-Regular";
        border-radius: 0;
        background: none;
        &.active {
          color: #fff;
          font-family: "DIN-Bold";
        }

        &:hover {
          border-radius: 54px;
          background-color: #333137;
        }
      }
      .el-input__inner {
        border: 0.0625rem solid #c2c2c2;
        border-radius: 0;
        &:focus {
          border: 0.0625rem solid #c2c2c2;
          border-radius: 0;
        }
      }
      .btn-prev,
      .btn-next {
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
        .el-icon-arrow-right:before {
          color: #fff;
        }
        &:hover {
          border-radius: 54px;
          background-color: #333333;
          .el-icon-arrow-left:before {
            color: #e8e8e8;
          }
          .el-icon-arrow-right:before {
            color: #e8e8e8;
          }
        }
      }
      .btn-prev[class="btn-prev disabled"] {
        border-radius: 54px;
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
      }
      .btn-next[class="btn-next disabled"] {
        border-radius: 54px;
        background: none;
        .el-icon-arrow-right:before {
          color: #fff;
        }
      }
      button {
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        padding: 0;
      }
    }
  }
}
/deep/ .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  height: 32px;
  color: #fff;
}
/deep/ .el-pagination__editor.el-input {
  .el-input__inner {
    width: 42px;
    height: 28px;
    color: #7a757b;
    border: solid 1px #4e4a4d;
    border-radius: 4px !important;
    background: none;
    &:hover {
      border: solid 1px #868285;
      background-color: #423f43;
    }

    &:active,
    &:focus {
      border: solid 1px #868285;
      color: #fff;
      background-color: #333137;
    }
  }
}
/deep/ .el-tag {
  border: none;
}
.dialog-body {
  display: flex;
  flex-wrap: wrap;
  .item-list {
    margin-right: 8px;
    margin-bottom: 8px;
    list-style-type: none;
    border-radius: 2px;
    border: solid 2px #605e61;
    &:hover {
      border: solid 2px #45a8cc;
    }
    &:active {
      background-color: rgba(69, 168, 204, 0.1);
      border: solid 2px #45a8cc;
    }
    &:nth-last-child(3) {
      margin-right: 16px;
    }
  }
  .li-back-ground {
    border: solid 2px transparent;
    border-radius: 2px;
    font-family: "DIN-Bold";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    background-color: rgba(69, 168, 204, 0.5);
    &:hover {
      background-color: #45a8cc;
    }
    &:active {
      background-color: rgba(69, 168, 204, 0.4);
    }
  }
  .tag-dialog {
    line-height: 32px;
    padding: 0 12px;
    height: 32px;
    border-radius: 2px;
    color: #ffffff;
    background-color: transparent;
    cursor: pointer;
  }
  .add-group-btn {
    width: 106px;
    height: 36px;
    line-height: 36px;
    padding: 0;
    border: none;
    border-radius: 2px;
    color: #ffffff;
    vertical-align: middle;
    background-color: rgba(225, 225, 225, 0.1);
    cursor: pointer;
    &:hover {
      border: none;
      border-radius: 2px;
      color: #ffffff;
      background-color: #504d52;
    }
    &:active {
      border: none;
      border-radius: 2px;
      background-color: #605c61;
    }
    .plus-circle {
      margin-top: -4px;
      margin-right: 3px;
      vertical-align: middle;
      width: 14px;
    }
  }
  .input-value {
    margin-bottom: 8px;
    align-items: center;
    .input {
      width: 128px;
      height: 36px;
      padding: 15px;
      border: solid 1px #45a8cc;
      border-radius: 2px;
      color: #ffffff;
      background: #27252a;
    }
    .save {
      width: 45px;
      height: 36px;
      padding: 0;
      border: #45a8cc;
      border-radius: 0 !important;
      background: #45a8cc;
      font-family: "DIN-Regular";
      font-size: 14px;
      color: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
    }
    .cancel {
      width: 44px;
      height: 36px;
      margin-left: 4px;
      padding: 0;
      border: rgba(255, 255, 255, 0.1);
      border-radius: 2px;
      color: #ffffff;
      background-color: rgba(255, 255, 255, 0.1);
      box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
    }
  }
}

/deep/ {

  .header-pos-normal {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-normal {
        background-image: url("../../assets/img/sortArrow-hover.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-normal {
        background-image: url("../../assets/img/sortArrow-hover.svg");
      }
    }
  }
  .header-pos-up {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-up {
        background-image: url("../../assets/img/arrow-up-hover,FOCUS.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-up {
        background-image: url("../../assets/img/arrow-up-hover,FOCUS.svg");
      }
    }
  }
  .header-pos-down {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-down {
        background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-down {
        background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
      }
    }
  }
  .header-neg-normal {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-normal {
        background-image: url("../../assets/img/sortArrow-hover.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-normal {
        background-image: url("../../assets/img/sortArrow-hover.svg");
      }
    }
  }
  .header-neg-up {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-up {
        background-image: url("../../assets/img/arrow-up-hover,FOCUS.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-up {
        background-image: url("../../assets/img/arrow-up-hover,FOCUS.svg");
      }
    }
  }
  .header-neg-down {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-down {
        background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-down {
        background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
      }
    }
  }
  .header-tot-normal {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-normal {
        background-image: url("../../assets/img/sortArrow-hover.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-normal {
        background-image: url("../../assets/img/sortArrow-hover.svg");
      }
    }
  }
  .header-tot-up {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-up {
        background-image: url("../../assets/img/arrow-up-hover,FOCUS.svg");
      }
    }
    &:active {
      background-color: #605c61;
    }
  }
  .header-tot-down {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
      .arrow-down {
        background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
      }
    }
    &:active {
      background-color: #605c61;
      .arrow-down {
        background-image: url("../../assets/img/arrow-down-hover,FOCUS.svg");
      }
    }
  }
  .header-groups {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-family: "DIN-Regular";
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    cursor: pointer;
    &:hover {
      background-color: #504d52;
    }
    &:active {
      background-color: #605c61;
    }
  }
  .header-companies {
    height: 48px;
    padding: 0 0 0 6px;
    font-size: 14px;
    font-family: "DIN-Regular";
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
    .el-table th div {
      padding-left: 16px !important;
    }
  }
  .header-operation {
    height: 48px;
    padding: 0;
    font-size: 14px;
    font-family: "DIN-Regular";
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    background-color: #3b3a3f;
  }
  .row-class{
    height: 72px;
    background-color: #333138;
    color: #ffffff;
    &.current-row {
      td {
        background-color: #423f43;
      }
    }
  }
  .el-table {
    background-color: #333138;
  }
  .el-table::before {
    background-color: #565357;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #423f43 !important;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #27252a;
  }
  .el-table th.is-leaf {
    border-bottom: none;
  }
  .el-table__empty-block {
    background-color: #333138;
    .el-table__empty-text {
      color: #ffffff;
    }
  }
  .delete-dialog {
    .el-dialog {
      border-radius: 8px;
      background-color: #333138;
      box-shadow: 0px 29px 50px 0px rgba(5, 69, 92, 0.1);
      .el-dialog__headerbtn {
        top: 26px;
      }
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          color: #ffffff;
        }
      }
      .el-dialog__body {
        padding: 32px 0 0 32px;
      }
      .el-dialog__footer {
        padding: 42px 32px 32px 0px;
      }
    }
  }
  .edit-dialog {
    .el-dialog {
      background-color: #333138;
      border-radius: 8px;
      .el-dialog__header {
        padding: 32px 0 0 32px;
        .el-dialog__title {
          color: #ffffff;
        }
      }
      .el-dialog__body {
        padding: 24px 32px;
      }
    }
  }
}
a {
  text-decoration: none;
}
.router-link-active {
  text-decoration: none;
}
</style>
<style lang="scss">
.el-table-filter {
  margin-left: 46px !important;
  margin-top: 8px !important;
  border: none !important;
  border-radius: 4px !important;
  background-color: #17171b !important;
  .el-table-filter__content {
    background-color: #17171b;
    min-width: 152px;
    .el-table-filter__checkbox-group {
      padding: 0;
      .el-checkbox:hover {
        background-color: #222227;
      }
    }
    .el-table-filter__bottom button {
      color: #ffffff;
      &:hover {
        display: block;
        height: 52px;
        width: 32px;
        background-color: #423f43;
        border-radius: 2px;
      }
    }
    .el-checkbox {
      height: 32px;
      line-height: 32px;
      margin: 0 13px;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #ffffff;
    }
    .el-checkbox__label {
      color: #ffffff;
    }
    .el-checkbox__inner {
      background-color: #17171b;
      border: 1px solid rgba(225, 225, 225, 0.3);
    }
  }
  .el-table-filter__bottom {
    border-top: 1px solid #3b3a3f;
    .is-disabled {
      color: #ffffff;
    }
  }
}
</style>
